export class SelectItem {

    constructor(
        public value: any,
        public selected = false) {
    }
}
